import Component from '../component/component';

import './gift-dropdown.scss';

export default class GiftDropdown extends Component {
    static initSelector: string = '.gift-dropdown';

    public button: HTMLElement;

    constructor(element: HTMLElement) {
        super(element);

        this.button = this.element.querySelector('.gift-dropdown__trigger');

        this.init();
    }

    init(): void {
        this.button.addEventListener('click', this.toggleHandler.bind(this));
    }

    toggleHandler(): void {
        this.element.classList.toggle('is-open');
    }
}
